import React, { useState } from "react";
import { Crest } from "@/components/Crest";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Laboratoire() {
  const params = new URLSearchParams(window.location.search);
  const [f, setF] = useState({ name: "", email: "", phone: "", country: "", role: "parent" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || (!f.email && !f.phone)) return toast.error("Votre nom et un email ou WhatsApp sont requis.");
    setBusy(true);
    try {
      const r = await fetch(`${BACKEND}/api/public/laboratoire/subscribe`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...f, ref: params.get("ref") || "" }),
      });
      if (!r.ok) throw new Error("fail");
      setDone(true);
    } catch { toast.error("Une erreur est survenue. Réessayez."); } finally { setBusy(false); }
  };

  const I = "w-full bg-white/5 border border-white/15 rounded-sm px-4 py-3 text-paper placeholder:text-paper/30 focus:border-heraldic focus:outline-none";

  return (
    <div className="min-h-screen bg-[#0B0D12] text-paper flex items-center justify-center px-5 py-12" data-testid="laboratoire-page">
      <div className="w-full max-w-xl">
        <div className="flex items-center gap-3 mb-8"><Crest className="h-10 w-10" /><span className="font-serif text-xl">Simo University</span></div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-heraldic mb-3">Sur invitation · Accès gratuit</div>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight">Laboratoire Télestologique<br /><span className="text-heraldic">des Parents-Chercheurs</span></h1>
        <p className="text-paper/60 mt-5 text-base leading-relaxed">
          Rejoignez le cercle du Professeur Dr Landry Simo et recevez, chaque semaine, des outils rigoureux pour développer
          l'intelligence la plus profonde chez votre enfant — issus de la <span className="text-paper">téléstologie</span>,
          la science de ce que l'être humain peut devenir.
        </p>
        <p className="text-paper/40 mt-3 text-sm italic">« Ne confondez jamais ce que les humains deviennent habituellement avec ce qu'ils sont capables de devenir. »</p>

        {done ? (
          <div className="mt-8 border border-heraldic/40 bg-heraldic/10 rounded-sm p-6" data-testid="laboratoire-success">
            <div className="font-serif text-2xl">Bienvenue au Laboratoire.</div>
            <p className="text-paper/60 mt-2 text-sm">Vous êtes inscrit(e). Votre première transmission arrive bientôt. Partagez ce lien avec d'autres parents-chercheurs autour de vous.</p>
            <button onClick={() => navigator.clipboard.writeText(window.location.href).then(() => toast.success("Lien copié"))} data-testid="laboratoire-share" className="mt-4 border border-white/20 px-4 py-2 rounded-sm text-sm hover:bg-white/5">Copier le lien à partager</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-3" data-testid="laboratoire-form">
            <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Votre nom complet" className={I} data-testid="lab-name" />
            <input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} type="email" placeholder="Votre email" className={I} data-testid="lab-email" />
            <input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="WhatsApp (avec indicatif, ex. +237…)" className={I} data-testid="lab-phone" />
            <div className="grid grid-cols-2 gap-3">
              <input value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} placeholder="Pays (ex. Cameroun)" className={I} data-testid="lab-country" />
              <select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} className={I} data-testid="lab-role">
                <option value="parent">Parent</option>
                <option value="educator">Éducateur / Enseignant</option>
                <option value="school">École / Institution</option>
                <option value="other">Autre</option>
              </select>
            </div>
            <button type="submit" disabled={busy} data-testid="lab-submit" className="w-full bg-heraldic text-white font-medium py-3.5 rounded-sm hover:opacity-90 transition-opacity disabled:opacity-40">
              {busy ? "Inscription…" : "Rejoindre le Laboratoire — c'est gratuit"}
            </button>
            <p className="text-paper/30 text-xs text-center">Contenu de très haute qualité. Vous pouvez vous désinscrire à tout moment.</p>
          </form>
        )}
      </div>
    </div>
  );
}
